













































































































import {Component, Prop, Vue} from 'vue-property-decorator';
  import MainMenuItem from '@/components/main-menu/MainMenuItem.vue';
  import { UserStore } from '@/store/user-module';
  import { successButtonColorClass } from '@/utlitities/color';
  import { AbsenceStore } from '@/store/absence-store';
  import StBadge from '@/components/basic/StBadge.vue';
import { ApprovalStore } from "@/store/approval-store";

  @Component({
    components: {
      StBadge,
      MainMenuItem,
    },
  })
  export default class MainMenu extends Vue {
    @Prop({default: false}) admin!: boolean;

    get dataLoaded() {
      return UserStore.dataLoaded;
    }

    get isColiquio(){
      return UserStore.userSettings.accountName == 'coliquio'
    }

    get canViewFixedPriceProjectReports(){
      return UserStore.userSettings.useFixedPriceProjects && UserStore.userSettings.CanViewRates && UserStore.userSettings.CanViewTimeEntriesForEmployees && UserStore.userSettings.CanViewCustomerAndProjects;
    }

    get useProjectTimeTracking(){
      return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
    }

    get useTeamOverview() {
      return UserStore.userSettings.featureFlagTeamOverview && UserStore.userSettings.CanViewTeamOverview;
    }

    get useTimeAccountTeamOverview() {
      return UserStore.userSettings.featureFlagTimeAccountTeamOverview && UserStore.userSettings.CanViewTeamOverview && UserStore.currentUser.tempUseNewTimeAccountSummary;;
    }

    get useTimeApproval() {
      return UserStore.userSettings.featureFlagTimeApproval && UserStore.userSettings.CanApproveTimeEntryDays;
    }

    get userSettings() {
      return UserStore.userSettings;
    }

    get menuClass() {
      return UserStore.userSettings.menuColor.toString().toLowerCase();
    }

    get successButtonColor() {
      return successButtonColorClass(UserStore.userSettings.successButtonColor);
    }

    get accountPaymentIsSetup() {
      return UserStore.userSettings.paymentStatus.paymentIsSetup;
    }

    get useAbsences() {
      return UserStore.userSettings.useAbsences;
    }

    get useTimeAccount() {
      return UserStore.userSettings.useTimeAccount && !UserStore.userSettings.featureFlagHideTimeAccount;
    }

    get useBillableTarget() {
      return UserStore.userSettings.featureFlagBillableTarget && (UserStore.userSettings.CanEditAccount || UserStore.userSettings.hasBillableTarget);
    }

    get openAbsenceRequestCount() {
      return AbsenceStore.openAbsenceRequestCount;
    }

    get openApprovalCount() {
      return ApprovalStore.openApprovalRequestCount;
    }

    get showMasterdataMenu() {
      return (
        this.userSettings.CanEditCustomersAndProjects || this.userSettings.CanViewCustomerAndProjects ||
        (this.userSettings.useProjectTasks && this.userSettings.CanEditProjectTasks) ||
        this.userSettings.CanEditRateRules ||
        (this.userSettings.useTags && this.userSettings.CanEditTags) ||
        this.userSettings.CanEditUsers ||
        this.userSettings.CanEditPublicHolidays
      );
    }
  }
